import FlyoutMenu from '@/components/layout/FlyoutMenu'
import { ChevronDownIcon, PlusIcon } from '@heroicons/react/24/outline'
import { useNavigate } from '@tanstack/react-router'

import { TaskType } from '@droidmap/project-service-contract'

import { taskTypeMenuItems } from './taskTypes'

interface NewTaskButtonProps {
  orgId: string
  projectId: string
}

/**
 * "New Task" trigger — a dropdown of task types (sharing the canonical
 * taskTypeOptions with the in-page selection cards). Picking a type opens the
 * create flow pre-set to it via `?type=`.
 */
export const NewTaskButton = ({ orgId, projectId }: NewTaskButtonProps) => {
  const navigate = useNavigate()

  const go = (type: 'photogrammetry' | 'gcp') =>
    navigate({
      to: '/orgs/$orgId/projects/$projectId/tasks/create',
      params: { orgId, projectId },
      search: { type },
    })

  return (
    <FlyoutMenu
      buttonVariant="default"
      buttonSize="sm"
      autoCloseDelay={0}
      buttonContent={
        <span className="flex items-center gap-1.5">
          <PlusIcon className="h-4 w-4" />
          New Task
          <ChevronDownIcon className="h-3.5 w-3.5 opacity-80" />
        </span>
      }
    >
      {taskTypeMenuItems((type) =>
        go(type === TaskType.Photogrammetry ? 'photogrammetry' : 'gcp'),
      )}
    </FlyoutMenu>
  )
}
